module.exports = __webpack_public_path__ + "media/images/page/top/top_img_10-94373417bcce208754fba3db13665b72.png";